import { useBusinessPreferences } from 'hooks/usePreferences';
import { formatPhoneForDisplay } from '../../../utils/phoneUtils';
import { getTimezoneLabel } from '../../../utils/timezones';

/**
 * Custom phone number cell renderer that formats phone numbers according to business preferences
 * Uses context-based preferences for instant loading (no delay)
 */
const PhoneNumberCell = ({ value }) => {
    const { preferences } = useBusinessPreferences();

    if (!value) return null;

    // Use the utility function to format the phone number
    // Preferences are immediately available via context, no loading delay
    const { displayText } = formatPhoneForDisplay(value, preferences);

    return displayText;
};

export const locationColumns = [
    {
        Header: 'Address',
        accessor: 'addrNo',
    },
    {
        Header: 'Street',
        accessor: 'addrStreet',
        enableFilter: true,
    },
    {
        Header: 'City',
        accessor: 'addrCity',
        enableFilter: true,
    },
    {
        Header: 'Province',
        accessor: 'addrProvince',
    },
    {
        Header: 'Phone',
        accessor: 'phone',
        enableFilter: true,
        Cell: PhoneNumberCell
    },
    // {
    //     Header: 'Timezone',
    //     accessor: 'timezone',   
    //     Cell: ({ value }) => getTimezoneLabel(value),
    //     enableFilter: true,
    // },
    {
        Header: 'Alias',
        accessor: 'storePrefix',
        disableSortBy: true,
    },
]